import { DatePickerValueChangeEvent } from '@/interfaces';

export function isSingleDateEvent(
  value: DatePickerValueChangeEvent,
): value is Date {
  return !!value && value instanceof Date && !Array.isArray(value);
}
